import React from "react";

export default function TopFarmers({ farmers }) {
  return (
    <div className="mt4">

      <h3 className="f3">
        Top Farmers This Month
      </h3>

      <article className="bg-white shadow-4 br3 pa3">

        <table className="collapse w-100">
          <thead>
            <tr>
              <th className="tl pa2">#</th>
              <th className="tl pa2">Farmer</th>
              <th className="tr pa2">Weight (KG)</th>
            </tr>
          </thead>

          <tbody>

            {farmers.map((farmer, index) => (
              <tr key={index}>
                <td className="pa2">
                  {index + 1}
                </td>

                <td className="pa2">
                  {farmer.fullname}
                </td>

                <td className="pa2 tr">
                  {farmer.weight.toFixed(2)}
                </td>
              </tr>
            ))}

          </tbody>
        </table>

      </article>

    </div>
  );
}